// React
import React from 'react';
import Dropzone from 'react-dropzone';
import {
  Row,
  Col,
  Form,
  Input,
  Label,
  Modal,
  Button,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from 'reactstrap';

// Containers Injections
import {
  Currency,
  createData,
  SelectInput,
  ModalEditValue,
  createDataWithLabel,
  BillsCardAttachment,
  convertEventSelectToTarget,
} from '../../containers/componentsInjection';

export const BillsToReceiveFormPage = ({
  isOpen,
  toggle,
  isOpen2,
  toggle2,
  offices,
  accounts,
  isUpdate,
  categories,
  validation,
  lastUpdated,
  selectedFile,
  organizations,
  paymentMethods,
  isConfirmAction,
  setSelectedFile,
}) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={() => {
          toggle();
          setSelectedFile([]);
        }}
        centered
        zIndex={10000}
        size={'lg'}
        id="staticBackdrop"
        backdrop="static"
      >
        <Form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
          }}
        >
          <ModalHeader
            toggle={() => {
              toggle();
              setSelectedFile([]);
            }}
          >
            {!isUpdate
              ? 'Nova Receita'
              : isConfirmAction
              ? 'Confirmar Receita'
              : 'Editar Receita'}
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={4}>
                <div className="mb-3 d-flex">
                  <div className="w-100">
                    <Label className="form-label" htmlFor="balance">
                      {isConfirmAction ? 'Valor Efetivo R$' : 'Valor R$'}
                    </Label>
                    <div className="d-flex align-items-center">
                      <Currency
                        id="balance"
                        name="balance"
                        className="form-control"
                        onChange={(e, valueWithoutMask) => {
                          validation.handleChange({
                            target: {
                              name: 'balance',
                              value: valueWithoutMask,
                            },
                          });
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.balance}
                        invalid={
                          !!(
                            validation.touched.balance &&
                            validation.errors.balance
                          )
                        }
                      />
                      {/* <i
                        role="button"
                        className="ri-calculator-fill fs-15 ms-2"
                        onClick={() => {
                          toggle2();
                          toggle();
                        }}
                      /> */}
                    </div>
                  </div>
                </div>
              </Col>

              <Col md={4}>
                <div className="mb-3">
                  <Label for="expirationDate" className="form-label">
                    {isConfirmAction ? 'Data Efetiva' : 'Vencimento'}
                  </Label>
                  <Input
                    type="date"
                    id="expirationDate"
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                    value={validation.values.expirationDate}
                    invalid={
                      !!(
                        validation.touched.expirationDate &&
                        validation.errors.expirationDate
                      )
                    }
                  />
                </div>
              </Col>

              <Col md={4}>
                <Label className="form-label" htmlFor="documentNumber">
                  Número Documento
                </Label>
                <Input
                  type="text"
                  id="documentNumber"
                  name="documentNumber"
                  className="form-control"
                  onBlur={validation.handleBlur}
                  onChange={validation.handleChange}
                  value={validation.values.documentNumber}
                />
              </Col>

              <Col md={12}>
                <div className="mb-3">
                  <Label className="form-label" htmlFor="description">
                    Descrição
                  </Label>
                  <Input
                    type="text"
                    id="description"
                    name="description"
                    className="form-control"
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                    value={validation.values.description}
                    invalid={
                      !!(
                        validation.touched.description &&
                        validation.errors.description
                      )
                    }
                  />
                </div>
              </Col>

              <Col md={12}>
                <div className="mb-3">
                  <Label htmlFor="organization" className="form-label">
                    Organização
                  </Label>
                  <SelectInput
                    options={createData(organizations || [])}
                    inputId="organization"
                    className="form-control"
                    placeholder="Selecione uma organização"
                    value={validation.values.organization}
                    onChange={(eventInput) => {
                      validation.handleChange(
                        convertEventSelectToTarget('organization', eventInput)
                      );
                    }}
                    onBlur={(eventInput) => {
                      validation.handleBlur(
                        convertEventSelectToTarget('organization', eventInput)
                      );
                    }}
                    invalid={
                      !!(
                        validation.touched.organization &&
                        validation.errors.organization
                      )
                    }
                  />
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="category" className="form-label">
                    Categoria
                  </Label>
                  <SelectInput
                    options={createDataWithLabel(categories || [])}
                    inputId="category"
                    className="form-control"
                    placeholder="Sem categoria"
                    value={validation.values.category}
                    onChange={(eventInput) => {
                      validation.handleChange(
                        convertEventSelectToTarget('category', eventInput)
                      );
                    }}
                    onBlur={(eventInput) => {
                      validation.handleBlur(
                        convertEventSelectToTarget('category', eventInput)
                      );
                    }}
                    invalid={
                      !!(
                        validation.touched.category &&
                        validation.errors.category
                      )
                    }
                  />
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="account" className="form-label">
                    Conta
                  </Label>
                  <SelectInput
                    options={createData(accounts || [])}
                    inputId="account"
                    className="form-control"
                    placeholder="Selecione uma conta"
                    value={validation.values.account}
                    onChange={(eventInput) => {
                      validation.handleChange(
                        convertEventSelectToTarget('account', eventInput)
                      );
                    }}
                    onBlur={(eventInput) => {
                      validation.handleBlur(
                        convertEventSelectToTarget('account', eventInput)
                      );
                    }}
                  />
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="paymentMethod" className="form-label">
                    Forma de Pagamento
                  </Label>
                  <SelectInput
                    options={createData(paymentMethods || [])}
                    inputId="paymentMethod"
                    className="form-control"
                    placeholder="Selecione uma forma de pagamento"
                    value={validation.values.paymentMethod}
                    onChange={(eventInput) => {
                      validation.handleChange(
                        convertEventSelectToTarget('paymentMethod', eventInput)
                      );
                    }}
                    onBlur={(eventInput) => {
                      validation.handleBlur(
                        convertEventSelectToTarget('paymentMethod', eventInput)
                      );
                    }}
                  />
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-3">
                  <Label htmlFor="office" className="form-label">
                    Escritório
                  </Label>
                  <SelectInput
                    options={createData(offices || [])}
                    inputId="office"
                    className="form-control"
                    placeholder="Selecione o escritório"
                    value={validation.values.office}
                    onChange={(eventInput) => {
                      validation.handleChange(
                        convertEventSelectToTarget('office', eventInput)
                      );
                    }}
                    onBlur={(eventInput) => {
                      validation.handleBlur(
                        convertEventSelectToTarget('office', eventInput)
                      );
                    }}
                    invalid={
                      !!(validation.touched.office && validation.errors.office)
                    }
                  />
                </div>
              </Col>

              <Col md={12}>
                <div className="mb-3">
                  <Label htmlFor="observations" className="form-label">
                    Observações
                  </Label>
                  <Input
                    type="text"
                    id="observations"
                    name="observations"
                    className="form-control"
                    onBlur={validation.handleBlur}
                    onChange={validation.handleChange}
                    value={validation.values.observations}
                  />
                </div>
              </Col>

              <Col>
                {selectedFile.length > 0 && (
                  <BillsCardAttachment
                    fileLink={selectedFile[0]?.link_view}
                    handleDelete={() => setSelectedFile([])}
                    fileName={selectedFile[0]?.name || selectedFile[0]?.file}
                  />
                )}
              </Col>
            </Row>
          </ModalBody>

          <ModalFooter
            className="bg-light d-flex justify-content-start align-items-center"
            style={{
              height: 40,
            }}
          >
            <Dropzone
              uploadMultiple={false}
              onDrop={async (acceptedFiles) => {
                const fileToBase64 = (file) =>
                  new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => {
                      const base64Data = reader.result.split(',')[1]; // remmove the preffix "data:image/png;base64,"
                      resolve(base64Data);
                    };
                    reader.onerror = () => {
                      reject(new Error('Failed to read file as base64'));
                    };
                    reader.readAsDataURL(file);
                  });

                const fileAsBase64 = await fileToBase64(acceptedFiles[0]);

                setSelectedFile(
                  acceptedFiles.map((file) =>
                    Object.assign({
                      file: file.path,
                      data: fileAsBase64,
                    })
                  )
                );
              }}
            >
              {({ getRootProps }) => (
                <div className="dz-message needsclick" {...getRootProps()}>
                  <i className="ri-attachment-2 fs-3 text-muted"></i>
                </div>
              )}
            </Dropzone>
          </ModalFooter>

          <ModalFooter className="border-top mt-1">
            <Col md={12}>
              <div className="d-flex align-items-center justify-content-between mt-2">
                <span className="card-text">
                  <small className="text-muted">{lastUpdated}</small>
                </span>
                <div className="text-end d-flex justify-content-end">
                  <Button
                    color="btn btn-link"
                    type="button"
                    onClick={() => {
                      toggle();
                      setSelectedFile([]);
                      validation.resetForm();
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button color="secondary" type="submit">
                    {isConfirmAction ? 'Confirmar' : 'Salvar'}
                  </Button>
                </div>
              </div>
            </Col>
          </ModalFooter>
        </Form>
      </Modal>

      <ModalEditValue
        isOpen2={isOpen2}
        toggle2={toggle2}
        isOpen={isOpen}
        toggle={toggle}
        organizations={organizations || []}
      />
    </>
  );
};
